/* 🤖 this file was generated by svg-to-ts */
export const matIconTableRestaurant: {
  name: 'table-restaurant';
  data: string;
} = {
  name: 'table-restaurant',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m21.96 9.73-1.43-5a.996.996 0 0 0-.96-.73H4.43c-.45 0-.84.3-.96.73l-1.43 5c-.18.63.3 1.27.96 1.27h2.2L4 20h2l.67-5h10.67l.66 5h2l-1.2-9H21c.66 0 1.14-.64.96-1.27zM6.93 13l.27-2h9.6l.27 2H6.93zm-2.6-4 .86-3h13.63l.86 3H4.33z"/></svg>`
};
